import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../App.scss";
import userAPI from "../api/userAPI";
import Footer from "../components/Footer";
import MultipleEntryPassWidget from "../components/MultipleEntryPass/MultipleEntryPassWidget";
import MenRun from "../img/menrun.png";
import WomanPilates from "../img/womanpilates.png";
import ConfirmPopup from "../shared/confirmPopup";

import WOWMainPageCover from "../img/WOWMainPageCover.png";
import {
  canBuyNewMultipleEntryPassSelector,
  checkCanPurchasePass,
  fetchMultipleEntryPasses,
  hasActiveMultipleEntryPassSelector,
} from "../store/multipleEntryPassSlice";
import { isPartnerClalit, isPartnerOvdimBari } from "../store/partnerStore";
import { updateIsHaveCreditCard } from "../store/userSlice";

const MainPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userParams = useSelector((state) => state.userSlice.userData);
  const mainUserParams = useSelector((state) => state.userSlice.mainUserData);

  const hasActiveMultipleEntryPass = useSelector(hasActiveMultipleEntryPassSelector);

  const canBuyNewMultipleEntryPass = useSelector(canBuyNewMultipleEntryPassSelector);
  const { t } = useTranslation();
  const isClalit = useSelector(isPartnerClalit);
  const isOvdimBari = useSelector(isPartnerOvdimBari);

  const [showBookingPopup, setShowBookingPopup] = useState(false);

  const showWidgetBuyMultipleEntryPass = !hasActiveMultipleEntryPass && canBuyNewMultipleEntryPass;

  const getBookingClickCount = () => {
    return parseInt(localStorage.getItem("freefit_workout_booking_clicks") || "0");
  };

  const incrementBookingClickCount = () => {
    const currentCount = getBookingClickCount();
    localStorage.setItem("freefit_workout_booking_clicks", (currentCount + 1).toString());
  };

  const handleBookWorkoutClick = () => {
    const clickCount = getBookingClickCount();
    if (clickCount < 2) {
      setShowBookingPopup(true);
    } else {
      navigate("/roomChoice");
    }
  };

  const checkCreditCard = async () => {
    try {
      let isHaveCreditCard = await userAPI.isClientHaveCreditCard({
        token: mainUserParams.Token,
        id: mainUserParams.ID,
        phone: mainUserParams.Phone,
      });

      if (isHaveCreditCard.data.Error !== 0) {
        throw {
          code: isHaveCreditCard.data.Error,
          mess: isHaveCreditCard.data.Message,
        };
      }

      dispatch(updateIsHaveCreditCard(JSON.parse(isHaveCreditCard.data.Data).HasCreditCard));
    } catch (error) {
      console.error("Failed to check credit card:", error);
    }
  };

  const handlePopupConfirm = () => {
    incrementBookingClickCount();
    setShowBookingPopup(false);
    navigate("/roomChoice");
  };

  useEffect(() => {
    if ((isClalit || isOvdimBari) && mainUserParams?.Token && mainUserParams?.ID && mainUserParams?.Phone) {
      const params = {
        token: mainUserParams.Token,
        id: mainUserParams.ID,
        phone: mainUserParams.Phone,
      };

      dispatch(fetchMultipleEntryPasses(params));
      dispatch(
        checkCanPurchasePass({
          token: mainUserParams.Token,
          id: mainUserParams.ID,
          phone: mainUserParams.Phone,
        }),
      );
    }

    if (isClalit || isOvdimBari) checkCreditCard();
  }, [mainUserParams]);

  return (
    <div className="main-page-container">
      <div className="main-page-wrapper">
        {isClalit || isOvdimBari ? (
          <div className="main-page-imgs">
            <img src={MenRun} alt="Man running" />
            <img src={WomanPilates} alt="Woman doing pilates" />
          </div>
        ) : (
          <div className="main-page-imgs">
            <img src={WOWMainPageCover} alt="WOW Main Page Cover" />
          </div>
        )}
        <div className="main-page-text">
          {isClalit || isOvdimBari ? (
            <>
              <p>{t("HEY_FIRST_NAME", { firstName: userParams.FirstName })}</p>
              {showWidgetBuyMultipleEntryPass ? (
                <div>
                  <MultipleEntryPassWidget isNew={true} />
                </div>
              ) : (
                <p>{t("MORE_THAN_1000_GYMS_FOR_25_ILS")}</p>
              )}
            </>
          ) : (
            <>
              <p>{t("HEY_FIRST_NAME", { firstName: userParams.FirstName })}</p>
              <p>{t("MORE_THAN_1000_GYMS_FOR_20_ILS")}</p>
            </>
          )}
        </div>

        <div className="main-page-btn-container-main">
          {isClalit && (
            <button className="main-page-btn big-button" onClick={handleBookWorkoutClick}>
              {t("BOOK_A_WORKOUT")}
            </button>
          )}
          <button
            className={isClalit ? "main-page-btn" : "main-page-btn big-button"}
            onClick={() => navigate("/fitExtendSelector")}
          >
            {t("WHERE_TO_GO")}
          </button>
          <button className="main-page-btn" onClick={() => navigate(`/orderHistory`)}>
            {t("MY_ORDERS")}
          </button>
          {(isClalit || isOvdimBari) && (
            <button className="main-page-btn" onClick={() => navigate(`/multipleEntryPass`)}>
              {t("MY_MULTIPLE_ENTRY_PASS")}
            </button>
          )}
        </div>
      </div>

      {isClalit && (
        <ConfirmPopup
          isOpen={showBookingPopup}
          setIsOpen={setShowBookingPopup}
          headerTextTop={t("NEW_UPDATES")}
          bodySubText={
            <div style={{ fontSize: "17px", lineHeight: "26px" }}>
              <div>{t("NEW_UPDATE_SUBTITLE")}</div>
              <div style={{ marginTop: "10px" }}>{t("NEW_UPDATE_OPTION_1-1")}</div>
              <div style={{ marginRight: "10px" }}>{t("NEW_UPDATE_OPTION_1-2")}</div>
              <div>{t("NEW_UPDATE_OPTION_2")}</div>
            </div>
          }
          btnText={t("CONFIRM")}
          handleClose={handlePopupConfirm}
        />
      )}

      <Footer />
    </div>
  );
};

export default MainPage;
